import { ClientsResponseInterface } from "../clients/clients-response.interface";
import { MiniUsersResponseInterface } from "../users/users-response.interface";
import { Brand } from "../../utils/enums.utils";

export interface LeadsResponseInterface {
  id: string;
  brand: Brand;
  description: string | null;
  estimated_amount: number | null;
  target_date: string | null;
  status: LeadStatus;
  remarks: string | null;
  brand_description: string | null;
  created_at: string | null;
  updated_at: string | null;
  created_by: MiniUsersResponseInterface | null;
  updated_by: MiniUsersResponseInterface | null;
  client: ClientsResponseInterface;
}

export enum LeadStatus {
  PENDING = 'Pending',
  DECLINED = 'Declined',
  ACTIVE = 'Active',
  PROPOSAL_CREATED = 'Proposal Created',
  LOST = 'Lost',
  DELETED = 'Deleted'
}